import { tabConfig } from '../components/SocialMedia/Chat/Tabs/DisplayToggles';
import { appState } from '../interfaces/common';
import { versionParser } from '../utils/helpers';

import {
  CURRENT_TAB,
  RESET_BANNER,
  RESET_CHAT_INFO,
  SET_CHAT_INFO,
  SET_ENCRYPTION_FLAG,
  UPDATE_ACCOUNTS,
  UPDATE_BANNER,
  UPDATE_CUSTOM_TRANSLATION,
  UPDATE_LOADER,
  UPDATE_SESSION,
  UPDATE_ERROR_WEBHOOKS,
  UPDATE_ERROR_LOGS,
  UPDATE_CONFIGURATIONS,
} from './types';

const chatInfoInitialState = {
  connectionId: '',
  widgetId: '',
  colorTheme: '',
  accountName: '',
  systemTags: {},
  welcomeMessage: '',
  logo: '',
  displayLogo: false,
  widgetTitles: {},
  emojiIcon: true,
  attachmentIcon: true,
  footerText: true,
  typingIndicator: true,
  hideChatLauncher: false,
  widgetPosition: '',
  enableLanguageSelection: true,
  enableAvatars: false,
  displayDownloadTranscript: true,
  disableVirusScan: false,
  headerTextColor: '',
  typingBeforeWelcomeMessage: true,
  disableGenAIWatermark: false,
  encryptAttachments: false,
  errorLogsData: [],
  showSpecialNote: false,
  specialNote: {},
  errorWebhooks: [],
  enableVoiceToText: false,
  enableVoiceNotes: false,
  isAgenticMessaging: false,
  enableMultiPhaseLoader: false,
  dynamicPhrases: [],
  enableHeartBeat: false
};

const initialState: appState = {
  isVerified: false,
  noofAsyncCalls: 0,
  isValid: false,
  sessionId: '',
  isLoading: false,
  accounts: [],
  bannerInfo: {
    message: '',
    variant: 'urgent',
  },
  chatInfo: chatInfoInitialState,
  encryptionEnableFlag: false,
  tabName: tabConfig.General, // Default to General
  customTranslationLanguageSet: {},
  errorLogsData: [],
  errorWebhooks: [],
};

const reducer = (state = initialState, action: any): appState => {
  switch (action.type) {
    case UPDATE_SESSION:
      return {
        ...state,
        isVerified: action.payload.verified,
        isValid: action.payload.valid,
        sessionId: action.payload.sessionId,
        languagesSupported: action.payload.languages,
        platformVersion: action.payload.platformVersion,
        isClientPublickeyPresent: action.payload.isClientPublickeyPresent,
        enableAgentTrainer: action.payload.enableAgentTrainer,
        genAiKeyOption: action.payload.genAiKeyOption,
        consumerId: action.payload.consumerId,
        managerId: action.payload.managerId,
        errorWebhooks: action.payload.errorWebhooks,
      };

    case UPDATE_LOADER:
      return {
        ...state,
        isLoading: action.payload,
        noofAsyncCalls: action.payload ? state.noofAsyncCalls + 1 : state.noofAsyncCalls - 1,
      };

    case UPDATE_ERROR_LOGS:
      return {
        ...state,
        errorLogsData: action.payload.data,
        nextToken: action.payload.nextToken,
      };
    case UPDATE_ERROR_WEBHOOKS:
      return {
        ...state,
        errorWebhooks: action.payload.data,
      };

    case UPDATE_ACCOUNTS:
      const { enableAgentTrainer, platformVersion: platformVersionFromState } = state;
      let beyondEightDotSeven = false,
        beyondEightDotEight = false,
        beyondEightDotSevenDotTwo = false;

      if (platformVersionFromState) {
        const { majorVersion, minorVersion, patchVersion } = versionParser(platformVersionFromState);
        beyondEightDotSeven = Boolean(
          majorVersion && (majorVersion > 8 || (majorVersion === 8 && minorVersion && minorVersion >= 7)),
        );
        beyondEightDotSevenDotTwo = Boolean(beyondEightDotSeven && patchVersion && patchVersion >= 2);
        beyondEightDotEight = Boolean(
          majorVersion && (majorVersion > 8 || (majorVersion === 8 && minorVersion && minorVersion >= 8)),
        );
      }

      let filteredAccounts = [];

      const accounts = action.payload;

      if (beyondEightDotSevenDotTwo || beyondEightDotEight) {
        filteredAccounts = [...accounts];
      } else if (beyondEightDotSeven) {
        filteredAccounts = accounts.filter((item: any) => {
          return !item.sdkPlatform;
        });
      } else {
        filteredAccounts = accounts.filter((item: any) => {
          return !item.sdkPlatform && item.platform !== 'custom';
        });
      }

      if (!beyondEightDotSeven || !enableAgentTrainer) {
        filteredAccounts = filteredAccounts.filter((item: any) => {
          return !item.isCustomerSimulator;
        });
      }

      return {
        ...state,
        accounts: filteredAccounts,
      };

    case UPDATE_CUSTOM_TRANSLATION:
      return {
        ...state,
        customTranslationLanguageSet: action.payload.customTranslationLanguageSet,
      };

    case UPDATE_BANNER:
      return {
        ...state,
        bannerInfo: action.payload,
      };

    case RESET_BANNER:
      return {
        ...state,
        bannerInfo: {
          message: '',
          variant: 'urgent',
        },
      };

    case SET_CHAT_INFO:
      return {
        ...state,
        chatInfo: { ...chatInfoInitialState, ...action.payload },
      };

    case RESET_CHAT_INFO:
      return {
        ...state,
        chatInfo: chatInfoInitialState,
      };

    case SET_ENCRYPTION_FLAG:
      return {
        ...state,
        encryptionEnableFlag: action.payload.encryptionEnableFlag,
      };
    case CURRENT_TAB:
      return {
        ...state,
        tabName: action.payload.tabName,
      };
    case UPDATE_CONFIGURATIONS:
      return {
        ...state,
        configRecords: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
